import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBed: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bed"><path d="M4 4.75C4 4.33579 4.33579 4 4.75 4H11.25V9.5H4V4.75Z" fill="currentColor"/><path d="M12.75 9.5V4H19.25C19.6642 4 20 4.33579 20 4.75V9.5H12.75Z" fill="currentColor"/><path d="M22 11.75C22 11.3358 21.6642 11 21.25 11H2.75C2.33579 11 2 11.3358 2 11.75V17.25C2 17.6642 2.33579 18 2.75 18H4V19.25C4 19.6642 4.33579 20 4.75 20C5.16421 20 5.5 19.6642 5.5 19.25V18H18.5V19.25C18.5 19.6642 18.8358 20 19.25 20C19.6642 20 20 19.6642 20 19.25V18H21.25C21.6642 18 22 17.6642 22 17.25V11.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBed;
